import * as paths from '../../../../../utils/Links'

import { LocationState, RedirectInfo } from '../types/IHttpStatusError'

export const getRedirectInfo = (isAuthenticated: boolean, state?: LocationState | null): RedirectInfo => {
  if (isAuthenticated) {
    return {
      title: state?.redirectPageTitle ?? 'Dashboard',
      path: state?.redirectPath ?? paths.getDashboard(),
    }
  }

  return {
    title: 'Sign In',
    path: paths.getSignIn(),
  }
}
